module.exports = __webpack_public_path__ + "media/marqeta_setup/marqeta_back-647f3bef.png";